export default __webpack_public_path__ + "static/media/bannerSMEs.85fbb05d.jpeg";